export default __webpack_public_path__ + "static/LeituraDisplayTwo-Roman-1c1a26772f14892668e5b808ceb9b1ab.woff";